import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-star-rating',
  template: `
    <div class="flex gap-1">
      @for (star of stars; track star; let i = $index) {
        <i class="fa-star transition-colors"
           [class.cursor-pointer]="!disabled"
           [class.cursor-default]="disabled"
           [class]="(i < rating ? 'fas text-theme-primary drop-shadow-md' : 'fal text-theme-text3') + ' ' + sizeClass"
           (click)="selectRating(i + 1)">
        </i>
      }
    </div>
  `
})
export class StarRatingComponent {
  @Input() rating: number = 0;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled = false;
  @Output() ratingChange = new EventEmitter<number>();

  stars = [1, 2, 3, 4, 5];

  get sizeClass(): string {
    switch (this.size) {
      case 'sm': return 'text-lg';
      case 'md': return 'text-2xl';
      case 'lg': return 'text-4xl';
    }
  }

  selectRating(value: number) {
    if (this.disabled) return;
    this.rating = value;
    this.ratingChange.emit(value);
  }
}
